import PropTypes from 'prop-types'
import database from 'services/firebase/database'
import { get, ref as databaseRef } from 'firebase/database'

/**
 * Retrieves the value of a node in Firebase Realtime Database.
 *
 * @param {string} path - The path to the node in the database.
 * @returns {Promise<any>} - A promise that resolves with the value of the node.
 */
const getNode = async (path) => {
  const snapshot = await get(databaseRef(database, path))
  return snapshot.val()
}

getNode.propTypes = {
  path: PropTypes.string.isRequired
}

export default getNode
